import { Typography, Row, Col } from 'antd';
import { setPaymentMethod, updatePaymentForm } from 'appRedux/actions/Tickets';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { get as _get, each, keys } from 'lodash';
import TextField from '../../../../../components/Form/Legacy/TextField';
import PaymentValidator from '../validators/PaymentValidator';

class Pix extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { competition } = this.props;
        this.props.dispatch(setPaymentMethod({ active: "pix", payments: competition.payments }));
    }

    cleanCardErrors() {

        var { form } = this.state;

        each(keys(form), (k) => {
            delete form[k].validationState;
            form[k].help = '';
        });

        this.setState(form);
    }

    handleInputChange(field, event) {

        const value = event.target.value;

        const isValid = new PaymentValidator({ active: 'pix', form: { [field]: value } }).validateField(field).isValid();

        this.props.dispatch(updatePaymentForm({
            value: value,
            field: field,
            valid: isValid
        }));
    }

    render() {
        const { payment, t } = this.props;

        return (
            <div className="gx-text-left" style={{ padding: 15 }}>
                <Typography.Paragraph> {t('pix_payment_description')}</Typography.Paragraph>
                <Row gutter={16}>
                    <Col xs={24} className="gx-mb-4 ">
                        <TextField
                            type="text"
                            name="fiscal_code"
                            label={t('boleto_fiscal_code') + ' *'}
                            onChange={this.handleInputChange.bind(this, 'fiscal_code')}
                            value={payment.form?.fiscal_code}
                            validationState={_get(payment.errors, 'fiscal_code.state')}
                            help={_get(payment.errors, 'fiscal_code.message')}
                            showCount={true}
                            maxLength={11}
                            placeholder={`${t('example_short')} 94271564656`}
                        />
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = function (state) {
    return {
        payment: state.tickets.payment
    };
};

export default connect(mapStateToProps)(withTranslation(['common'])(Pix))
